import { combineReducers, configureStore } from '@reduxjs/toolkit'
// import alertSlice from './alertSlice'
// import carSlice from './carSlice'
// import menuSlice from './menuSlice'
// import personSlice from './personSlice'
// import productHomeSlice from './productHomeSlice'
import userSlice from './userSlice'
import scannerSlice from './scannerSlice'
import boxSlice from './boxSlice'
import commentSlice from './commentSlice'
import supplyOrderSlice from './supplyOrderSlice'
import supplyBillSlice from './supplyBillSlice'
import supplierSlice from './supplierSlice'
import writeOffSlice from './writeOffSlice'
import settingsSlice from './settingsSlice'
// import errorSlice from './errorSlice'

const rootReducer = combineReducers({
    // menu: menuSlice,
    user: userSlice,
    scanner: scannerSlice,
    box: boxSlice,
    comment: commentSlice,
    supplyOrder: supplyOrderSlice,
    supplyBill: supplyBillSlice,
    supplier: supplierSlice,
    writeOff: writeOffSlice,
    settings: settingsSlice,
    // car: carSlice,
    // alert: alertSlice,
    // productHome: productHomeSlice,
    // person: personSlice,
    // error: errorSlice,
})

export const store = configureStore({
    reducer: rootReducer,
    // middleware: getDefaultMiddleware({
    //     serializableCheck: false,
    // }),
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }
    ),
})